import Card from "../components/card"
import UserSettingsPanel from "../components/userSettingsPanel"
import { useEffect, useState, useCallback } from "react"
import { useDispatch, useSelector } from "react-redux"
import { getToken } from "../redux/dataslices/tokenSlice"
import { useSnackbar } from "notistack"
import { useParams, useNavigate } from "react-router-dom"
import { getUserSettings, setUserSettings } from "../redux/dataslices/inventarisationSlice"
import { GetUserSettings, UpdateUserSettings, DeleteAllSubscriptions } from "../helpers/dataHandlers/Inventarisation"
import { useTranslation } from 'react-i18next'

function UserSettings() {
  const {redirect} = useParams()
  const {pageNumber} = useParams()
  const { t } = useTranslation()
  const token = useSelector(getToken)
  const dispatch = useDispatch()
  const { enqueueSnackbar } = useSnackbar()
  const [loading, setLoading] = useState(false)
  const userSettings = useSelector(getUserSettings)
  const [userSettingsData, setUserSettingsData] = useState()
  const navigate = useNavigate()

  const updateDataField = (field, value) => {
    dispatch(setUserSettings({...userSettings, [field]:value}))
    setUserSettingsData({...userSettingsData, [field]:value})
  }

  const purgeSubscriptions = () => {
    DeleteAllSubscriptions(token)
    .then(response => {
      enqueueSnackbar({ message: `(Inventarisation) ${t("zzz_temp_purge_subscriptions_completed")}`, variant: 'notification' })
      setLoading(false)
    })
    .catch(error => {
      enqueueSnackbar({ message: `(Inventarisation) ${error?.message}`, variant: 'error' })
      setLoading(false)
    })
  }

  const updateCompleted = useCallback((dataObject, redirect) => {
    dispatch(setUserSettings(dataObject))
    if(redirect != null) {
      navigate(redirect)
    }
  },[dispatch, navigate])

  const updateUserSettings = useCallback((redirect) => {
    UpdateUserSettings(token, { 
      id_owner: token.payload.sub,
      user_language: userSettingsData?.user_language
    })
    .then(response => { updateCompleted(response.data, redirect)})
    .catch(error => {
      enqueueSnackbar({ message: `(Inventarisation) ${error?.message}`, variant: 'error' })
      setLoading(false)
    })
  },[token, userSettingsData, enqueueSnackbar, updateCompleted])

  const redirectPage = useCallback(() => {
    if(redirect === "dashboard" || redirect === "customers" || redirect === "settings") {
      if(pageNumber) {
        updateUserSettings("/" + redirect + "/" + pageNumber)
      }
      else {
        updateUserSettings("/" + redirect)
      }
    }
    else {
      updateUserSettings("/dashboard")
    }
  },[redirect, pageNumber, updateUserSettings])
  
  const userSettingsCardProps = {
    titleVariant: 'h6',
    titleColor: '#FF6700',
    titleWeight: 600,
    titleText: 'settings',
    loading: loading,
    loadingText: "loading_settings",
    data: <UserSettingsPanel  
      id_owner={token.payload.sub}
      userSettingsData={userSettingsData}
      updateDataField={updateDataField}
      updateUserSettings={updateUserSettings}
      purgeSubscriptions={purgeSubscriptions}
      />
  }

  useEffect(() => {
    setLoading(true)
    const fetchData = async () => {
      GetUserSettings(token)
        .then(response => { dispatch(setUserSettings(response.data)) })
        .catch(error => {
          enqueueSnackbar({ message: `(Inventarisation) ${error?.message}`, variant: 'error' })
          setLoading(false)
        })
    }
    fetchData()
    // eslint-disable-next-line
  }, [token])
    
  useEffect(() => {
    if (!userSettings) return
    setLoading(true)
    setUserSettingsData(userSettings)

    // eslint-disable-next-line
  }, [userSettings])

  useEffect(() => {
    if (userSettingsData && userSettingsData !== null) {
      setLoading(false)
    }
  }, [userSettingsData])

  useEffect(() => {
    if (redirect) {
      redirectPage()
    }
  }, [redirect, redirectPage])

  return (
      <>
        <Card {...userSettingsCardProps} />
      </>
  )
}

export default UserSettings
